import { Component, Input } from '@angular/core';

import { PricePlan } from '@shared/price-plan/models';
import { RecurlySubscription } from '@shared/recurly/models';
import { FrontendModalService } from '@tablesready/frontend-modal';

@Component({
  selector: 'pause-or-cancel-subscription',
  templateUrl: './downgrade-subscription.component.html',
})
export class DowngradeSubscriptionComponent {
  @Input() pricePlan?: PricePlan;
  @Input() sub?: RecurlySubscription;
  @Input() blockActions = false;
  @Input() downgradeFromAnnual = false;
  @Input() timezone = '';
  @Input() accountFeatures = '';

  constructor(readonly modalController: FrontendModalService) { }

  response(result: boolean): void {
    this.modalController.dismiss({
      instance: this,
      result,
    });
  }

  close(): void {
    this.modalController.dismiss();
  }

  isPremiumPlan(): boolean {
    return this.pricePlan?.plan_code.includes('premium');
  }

  isFreePlan(): boolean {
    return this.pricePlan?.plan_code.includes('free');
  }
}
